import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { createHead } from '@unhead/vue/client';
import { RegleVuePlugin } from '@regle/core';
import App from '@/App.vue';
import { router } from '@/router';
import { i18n } from '@/i18n';
import { regleOptions } from '@/lib/validation/regle';

import '@/styles/tokens.css';
import '@/styles/base.css';
import '@/styles/prose.css';

const app = createApp(App);
app.use(createHead());
app.use(createPinia());
app.use(router);
app.use(i18n);
app.use(RegleVuePlugin, regleOptions);
app.mount('#app');
